import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './store'
import { AuthProvider } from './api/context/auth-context'
import AxiosProvider from './api/context/axios-context'

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
  <Provider store={store}>
    <AxiosProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </AxiosProvider>
  </Provider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
